import { Box, Flex } from "rebass/styled-components";
import SecondaryPosts from "./sections/SecondaryPosts";
import MobileApp from "./promotion/MobileApp";
import SubscribeBlock from "./promotion/SubscribeBlock";
import FindSitter from "./promotion/FindSitter";
import InfoBlock from "./promotion/InfoBlock";
import Post from "./Post";
import { InferredMedia, InferredPost } from "../types";
import { useGetMediaDataQuery } from "../generated/graphql";
import { getPostWithImg } from "../pages";
import Pagination from "./sections/Pagination";
import Loader from "./Loader";

interface Props {
  basePath: string;
  afterPath?: string;
  posts: InferredPost[];
  isMobile: boolean;
  pageSelected: number;
  totalPosts: number;
  slim?: boolean;
}

function PostPage(props: Props) {
  const { basePath, afterPath, posts, isMobile, pageSelected, totalPosts } =
    props;
  let mediaLoading = true;

  const getImages = (postIds: string[]) => {
    const { data: mediaData, loading } = useGetMediaDataQuery({
      variables: { postIds: postIds || [""] },
    });
    const newMedia: InferredMedia[] = mediaData?.mediaItems?.nodes || [];
    mediaLoading = loading;
    return newMedia;
  };

  const media = posts && getImages(posts.map((post) => post.id));
  const postWithImg = getPostWithImg(posts, media);

  const renderFindSitterSubscribe = () => {
    return (
      <Box
        key="findSitterSubs"
        sx={{ width: ["100%", "100%", "30%"], height: "fit-content" }}
      >
        {!props.slim && (
          <Box sx={{ mb: "32px" }}>
            <FindSitter origin="postPage" slim />
          </Box>
        )}
        <SubscribeBlock type="column" />
      </Box>
    );
  };

  const renderInfoBlock = () => {
    return (
      <Box key={"info"} sx={{ width: ["100%", "100%", "30%"] }}>
        <InfoBlock type="column" />
      </Box>
    );
  };

  const renderPosts = () => {
    return [...Array(posts.length + 2)].map((_, i) => {
      let comp = <></>;
      if (i < 2) {
        comp = postWithImg[i] && (
          <Post key={i} postData={postWithImg[i]} postType="scndPost" />
        );
      } else if (i === 2) {
        comp = renderFindSitterSubscribe();
      } else if (i > 2 && i < 10) {
        comp = postWithImg[i - 1] && (
          <Post key={i - 1} postData={postWithImg[i - 1]} postType="scndPost" />
        );
      } else if (i === 10) {
        comp = renderInfoBlock();
      } else {
        comp = postWithImg[i - 2] && (
          <Post key={i - 2} postData={postWithImg[i - 2]} postType="scndPost" />
        );
      }
      return comp;
    });
  };

  const renderPostsMobile = () => {
    return [...Array(posts.length + 1)].map((_, i) => {
      let comp = <></>;
      if (i < 2) {
        comp = postWithImg[i] && (
          <Post key={i} postData={postWithImg[i]} postType="scndPost" />
        );
      } else if (i === 2) {
        comp = renderFindSitterSubscribe();
      } else {
        comp = postWithImg[i - 1] && (
          <Post key={i - 1} postData={postWithImg[i - 1]} postType="scndPost" />
        );
      }
      return comp;
    });
  };

  return (
    <>
      <Box sx={{ my: "24px" }}>
        <SecondaryPosts>
          {isMobile ? renderPostsMobile() : renderPosts()}
        </SecondaryPosts>
      </Box>

      <Pagination
        basePath={basePath}
        afterPath={afterPath}
        pageSelected={pageSelected}
        totalPosts={totalPosts}
        maxNumPages={isMobile ? 6 : 8}
      />

      {isMobile && (
        <Flex sx={{ flexDirection: "column", gap: "24px", mb: "24px" }}>
          <MobileApp type="column" isMobile={isMobile} />
        </Flex>
      )}

      <SubscribeBlock type={isMobile ? "column" : "row"} />
    </>
  );
}

export default PostPage;
